require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconPublish.tsx
var IconPublish_exports = {};
__export(IconPublish_exports, {
  default: () => IconPublish_default
});
module.exports = __toCommonJS(IconPublish_exports);

// src/assets/monochrome/publish.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgPublish = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M17.6743 11.8937C14.9693 7.79505 12.152 7.26924 10 7.26924C7.84802 7.26924 5.03068 7.79505 2.32575 11.8937C2.11321 12.2156 2 12.592 2 12.9767C2 13.3615 2.11321 13.7379 2.32575 14.0598C5.03068 18.1584 7.84802 18.6842 10 18.6842C12.152 18.6842 14.9693 18.1584 17.6743 14.0598C17.8868 13.7379 18 13.3615 18 12.9767C18 12.592 17.8868 12.2156 17.6743 11.8937ZM16.233 13.125C14.9131 15.1249 13.2416 16.9765 10 16.9765C8.0828 16.9765 6.00061 16.51 3.76705 13.125C3.73781 13.081 3.72222 13.0294 3.72222 12.9767C3.72222 12.924 3.73781 12.8724 3.76705 12.8284C5.08688 10.8286 6.75843 8.97699 10 8.97699C11.9172 8.97699 13.9994 9.44348 16.233 12.8284C16.2622 12.8724 16.2778 12.924 16.2778 12.9767C16.2778 13.0294 16.2622 13.081 16.233 13.125Z", fill: "#818898" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M10 14.5946C10.9011 14.5946 11.6317 13.8703 11.6317 12.9767C11.6317 12.0832 10.9011 11.3589 10 11.3589C9.09886 11.3589 8.36834 12.0832 8.36834 12.9767C8.36834 13.8703 9.09886 14.5946 10 14.5946Z", fill: "#818898" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M3.92659 5.47161C3.97718 5.57194 4.04721 5.66141 4.13267 5.7349C4.21813 5.8084 4.31736 5.86448 4.42468 5.89995C4.532 5.93542 4.64532 5.94959 4.75816 5.94164C4.87101 5.93368 4.98116 5.90377 5.08235 5.85361C5.18353 5.80344 5.27376 5.73401 5.34788 5.64927C5.422 5.56453 5.47857 5.46614 5.51434 5.35973C5.55012 5.25331 5.5644 5.14095 5.55638 5.02906C5.54836 4.91717 5.51819 4.80795 5.4676 4.70762L4.65177 3.08975C4.60118 2.98942 4.53115 2.89995 4.44569 2.82646C4.36023 2.75296 4.261 2.69688 4.15368 2.66141C4.04636 2.62594 3.93304 2.61177 3.8202 2.61972C3.70735 2.62767 3.59719 2.65759 3.49601 2.70775C3.39483 2.75792 3.3046 2.82735 3.23048 2.91209C3.15635 2.99683 3.09979 3.09522 3.06402 3.20163C3.02824 3.30805 3.01396 3.42041 3.02198 3.5323C3.03 3.64419 3.06016 3.75341 3.11076 3.85374L3.92659 5.47161Z", fill: "#818898" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M14.9176 5.85361C15.122 5.95476 15.3585 5.97134 15.5752 5.89972C15.7919 5.82809 15.9711 5.67412 16.0734 5.47161L16.8892 3.85374C16.9914 3.65112 17.0082 3.41655 16.936 3.20163C16.8637 2.98672 16.7083 2.80906 16.504 2.70775C16.2996 2.60644 16.0631 2.58977 15.8463 2.66141C15.6296 2.73305 15.4504 2.88712 15.3482 3.08975L14.5324 4.70762C14.4306 4.91031 14.414 5.14473 14.4862 5.35953C14.5585 5.57433 14.7136 5.752 14.9176 5.85361Z", fill: "#818898" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M10 5.13455C10.2284 5.13455 10.4474 5.04459 10.6089 4.88446C10.7704 4.72433 10.8612 4.50714 10.8612 4.28068V1.85388C10.8612 1.62741 10.7704 1.41023 10.6089 1.25009C10.4474 1.08996 10.2284 1 10 1C9.77161 1 9.55257 1.08996 9.39107 1.25009C9.22957 1.41023 9.13884 1.62741 9.13884 1.85388V4.28068C9.13884 4.50714 9.22957 4.72433 9.39107 4.88446C9.55257 5.04459 9.77161 5.13455 10 5.13455Z", fill: "#818898" })
] });
var publish_default = SvgPublish;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconPublish.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconPublish = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(publish_default, {}) });
};
IconPublish.displayName = "IconPublish";
var IconPublish_default = IconPublish;
